import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
//import { GlobalConstants } from 'src/app/common/global-constants';
import { CategoryModel } from '../models/category.model';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {

  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/ProductCategories";


    form: FormGroup  =  CategoryModel.getFormGroup();
  constructor(private http : HttpClient, private userservice : UserService) {
    console.log("constructor : ProductCategoryService ");
    this.BaseURI = window.location.origin + "/api";
  }

  populateForm(item) {

    this.form.setValue(item);
   }

/*
   postDetail()
   {
      return this.http.post(this.BaseURI + this.apiController, this.formData);
   }


   putDetail()
   {
      return this.http.put(this.BaseURI + this.apiController + "/" + this.formData.id, this.formData);
   }
   */
   getDetail(id)
   {
      return this.http.get(this.BaseURI + this.apiController + "/" + id);
   }
 /*
   refreshList()
   {

     return this.http.get(this.BaseURI + this.apiController).toPromise().then(
       res => {
         this.list = res as CategoryModel[];

       }
     );
   }
*/

   getList()
   {
      return this.http.get(this.BaseURI + this.apiController);

   }


   insertData(item : CategoryModel) {
     item.createBy = this.userservice.getUserID();
     return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["id", "createTime"]));
   }

   updateData(item : CategoryModel) {
     return this.http.put(this.BaseURI + this.apiController + "/" + item.id, item);
   }


   deleteData(id)
   {
     return this.http.delete(this.BaseURI + this.apiController + "/" + id);

   }

   initializeFormGroup(){
    CategoryModel.initializeFormGroup(this.form);
 }
/*

   initializeFormGroup(){

     this.form.setValue({
      id : null,
      name : null,
      code: null,
      description:null,
      displayOrder : null,
      createBy: null,
      createTime : null,
     });

   }*/
}
